import { View, StyleSheet } from '@react-pdf/renderer';
import { theme } from '../theme';

const style = StyleSheet.create({
  pdfTableRowStyle: {
    width: '100%',
    height: 'auto',

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexWrap: 'nowrap',
    flexGrow: 0,
    flexShrink: 0,

    borderBottom: `1px solid ${theme.colors.primaryK1}`,
  },
});

export const PdfTableRow: React.FC = ({ ...props }) => (
  <View style={style.pdfTableRowStyle}>{props.children}</View>
);
